/**
 * Ex. foo_bar -> Foo Bar
 * @param {string}
 * @return {string}
 * */
export function parseNormalStringToWords(str = "") {
  if (typeof str !== "string") return;
  if (!str.length > 0) return;

  const s = str[0].toUpperCase() + str.substring(1, str.length);
  const words = s.split("_").join(" ");

  return words;
}

/**
 * Get queryString data
 * */
export function getQueryStringData() {
  const data = {};

  location.href.slice(
    location.href.indexOf("?") + 1,
    location.href.length
  )?.split("&")?.forEach(query => {
    const a = query.split("=");
    const key = a[0];
    const values = a[1]?.split("+");
    data[key] = values;
  });

  // clean data from location.href key
  delete data[location.href];

  return data;
}

/**
 * Returns an object from passed string
 * @param {string}
 * @return {object}
 * */
export function getKeyValuePair(str) {
  if (!str) return;

  const a = str.split(";");
  const obj = {};
  a?.forEach(el => {
    const keyVal = el.split("=");
    obj[keyVal[0]] = keyVal[1];
  });

  return obj;
}

/**
 * Explore block onScroll animation
 * */
export function initExploreOnScroll(expBlocks) {
  expBlocks?.forEach(exp => {
    const entries = exp.querySelectorAll(".explore-entry");
    if (entries?.length) {
      const [firstBlock, ...rest] = exp.querySelectorAll(".explore-entry");
      gsap.from(firstBlock, {
        scrollTrigger: {
          trigger: exp,
          start: "top center",
          end: () => innerHeight / 3 + " top",
          // markers: true
        },
        opacity: 1,
        y: innerHeight / 3,
        duration: 1,
        ease: "power4.out",
        onStart: () => {
          let delay = 1;

          rest?.forEach((exp, i) => {
            exp.classList.remove("not-ready");

            gsap.from(exp, {
              opacity: 0,
              y: "100%",
              duration: 1,
              delay: (delay + i) / 2
            });

            delay = delay / 2;
          });
        }
      });
    }    
  });
}

export function initMapLightboxes() {
  const maps = document.querySelectorAll(".js-map");
  maps?.forEach((map) => {
    const parent = map.closest(".content-section");
    const btn = parent?.querySelector(".js-btn-open-map");

    btn?.addEventListener("click", (e) => {
      e.preventDefault();

      document.querySelector("body > .js-map-lightbox")?.remove();
      const lightbox = document.querySelector("#template-map-lightbox")?.cloneNode(true);
      const img = lightbox?.querySelector(".js-lightbox-img");
      const btnClose = lightbox?.querySelector(".js-lightbox-close");
      const hideLightbox = () => {
        lightbox?.classList.remove("is-visible");
        setTimeout(() => {
          lightbox.remove();
        }, 300);
      }

      lightbox?.removeAttribute("id");
      lightbox?.addEventListener("click", hideLightbox);
      lightbox?.querySelector(".map-lightbox-body")?.addEventListener(
        "click",
        (e) => e.stopPropagation()
      );
      btnClose?.addEventListener("click", hideLightbox);
      console.log(img)
      img?.setAttribute("src", map.src);

      document.body.appendChild(lightbox);
      setTimeout(() => lightbox?.classList.add("is-visible"), 250);
    });
  });
}